import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {
  Router,
  Route,
} from 'react-router-dom';
import history from '../../../../../../../../../../services/history';
import Header from './components/Header';
import Reports from '../../../../../../../../../../scenes/Reports';
import Report from '../../../../../../../../../../scenes/Report';

const styles = {
  page: {
    padding: '20px',
  },
};

class RoutesContainer extends Component {
  render() {
    return (
      <Router history={history}>
        <div>
          <Header viewer={this.props.viewer} history={history} />
          <div style={styles.page}>
            <Route exact path="/" component={Reports} />
            <Route exact path="/reports" component={Reports} />
            <Route path="/reports/:reportId" component={Report} />
          </div>
        </div>
      </Router>
    );
  }
}

export default createFragmentContainer(
  RoutesContainer,
  graphql`
    fragment RoutesContainer_viewer on Viewer {
      ...Header_viewer
    }
  `,
);



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/components/RoutesContainer/RoutesContainer.js